import { render, staticRenderFns } from "./area.vue?vue&type=template&id=57198141&scoped=true"
import script from "./area.vue?vue&type=script&lang=js"
export * from "./area.vue?vue&type=script&lang=js"
import style0 from "./area.vue?vue&type=style&index=0&id=57198141&prod&scoped=true&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57198141",
  null
  
)

export default component.exports